import React from "react" ;
import PrivateMessagingAppBodyHeader from "./PrivateMessagingAppBodyHeader";
import {Route, Switch} from "react-router-dom";

import {PATH_PRIVATE_MESSAGING_ROOT} from "root/Wieldy/routePaths";
import ScrollRails from "../../Common/Body/ScrollRails";
import PrivateMessagingTab from "root/Wieldy/ApplicationModules/PrivateMessaging/Body/PrivateMessagingTab";

const PrivateMessagingAppBody= (props) =>
{
    return (
    <div className="dt-module__container">
        <PrivateMessagingAppBodyHeader />
        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={PATH_PRIVATE_MESSAGING_ROOT} render={(thisprops) => <PrivateMessagingTab resource_id='' {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>
            <ScrollRails />
        </div>
    </div>
    ) ;
}

export default PrivateMessagingAppBody;
